define(function (require, exports, module) {
    var BaseApiHeartbeatItem = require('./BaseApiHeartbeatItem');
    var Datasources = require('../../enums/DataSourceList');
    var DatasourceManager = require('datasource-manager/datasource-manager');
    var MessageService = require('message-service/message-service');
    var Moment = require('moment/moment');
    var logg = require('../../utils/core-log');
    var Superclass;
    var responseCodePreventReconnect = new Set([4200,4256, 4400, 4401,4404,4301,4429]);
    var initSocketState = {
        socket: null,
        preventReconnection: false,
        pushUpdateId: null,
        isLive:  false,
        isValidStartTime: false,
        isValidGameState: null,
        connectionAttempts: 6 // initial connection + 5 retry attempts
    }

    var ACCESS_TOKEN_CHANGE = 'accessTokenChange';

    function SocketApiHeartbeatItem (id, gameItem) {
        Superclass.constructor.call(this, id, gameItem);
    }

    BaseApiHeartbeatItem.spawn(SocketApiHeartbeatItem).define({
        init: function () {            
            MessageService.on(ACCESS_TOKEN_CHANGE, (token) => {
                this.setAccessToken.call(this, token);
            });
            
            this.socket = initSocketState.socket;
            this.preventReconnection = initSocketState.preventReconnection;
            this.pushUpdateId = initSocketState.pushUpdateId;
            this.isLive = initSocketState.isLive;
            this.isValidStartTime = initSocketState.isValidStartTime;
            this.connectionAttempts = initSocketState.connectionAttempts;
            this.isValidGameState = initSocketState.isValidGameState;
            this.executeHeartbeat();
        },
        onSocketMessage: function (e) {
            // data is coming to us as one big string, needs to be parsed
            const msg = JSON.parse(e.data);
            if (msg && msg.updateId){
                this.handleMessage(msg);
            }
        },
        onSocketClose: function (e) {
            //close socket, set to null, keep super HB
            this.connectionAttempts = this.connectionAttempts - 1;

            if (responseCodePreventReconnect.has(e?.code) || this.connectionAttempts == 0) {
                this.preventReconnection = true;
            }
            this.clean();
        },
        onSocketError: function (e) {
            //close socket, set to null, keep super HB
            this.clean();
            //prevent re-opening the socket for now
            this.preventReconnection = true;
        },
        buildSocketURL: function () {
            this.setParams();
            let datasource;
            if (this.gameItem?.useNoDelayConnection === true) {
                datasource = DatasourceManager.get(Datasources.NODELAYSOCKET);
            } else {
                datasource = DatasourceManager.get(Datasources.SOCKET);
            }
            return datasource.getUrl(this.params);
        },
        handleMessage: function (msg) {
            this.pushUpdateId = msg.updateId;
            Superclass.executeHeartbeat.call(this);
        },
        executeHeartbeat: function (e) {
            if (!this.secondHelping || !this.socket || this.preventReconnection) {
                Superclass.executeHeartbeat.call(this);
            } else {
                // keep the socket alive
                var socket = this.socket;
                var readyState = socket && socket.readyState;
                
                if (socket) {
                    if (readyState === socket.OPEN) {

                        try {
                            socket.send && socket.send('Gameday5');
                            this.connectionAttempts = initSocketState.connectionAttempts - 1;
                          } catch (error) {
                            logg.warn('Gameday5 websocket send error', error);
                            !!socket.close && socket.close();
                        }
    
                    } else if (readyState === socket.CLOSING) {
                        this.onSocketClose({});
                    }
                } else {
                    Superclass.executeHeartbeat.call(this);
                    logg.warn('Gameday5 websocket executeHeartbeat error', socket);
                }

            }
        },
        validateGameState: function () {

            if (this.isValidGameState !== null) {
                return this.isValidGameState;
            }
            
            //we only want to open the socket if the same start time is within our window OR if the game is Live
            var game = this.gameItem;
            var gameData = this.gameItem.getGameData()?.api?.gameData;

            // Check if the game start time is within the magic window
            var windowLowerBound = Moment().subtract(game.webSocketWindow, 'hours');
            var windowUpperBound = Moment().add(game.webSocketWindow, 'hours');

            var startTime = Moment(gameData?.datetime?.dateTime);
            this.isValidStartTime = startTime.isBetween(windowLowerBound, windowUpperBound);
            this.isLive = gameData?.status?.abstractGameCode === 'L';
            this.isValidGameState = this.isValidStartTime || this.isLive;
            return this.isValidGameState;
        },
        canOpenSocket: function () {
            // check socket state & validate game data
            return (this.secondHelping && !this.socket && !this.preventReconnection && this.connectionAttempts > 0 && this.validateGameState())
        },
        setUpSocket: function () {
            var socketURL = this.buildSocketURL();
            var protocol = SocketApiHeartbeatItem.authAccessToken ? ['gameday', SocketApiHeartbeatItem.authAccessToken] : undefined;

            //Open Sesame!
            this.socket = !protocol ? new WebSocket(socketURL) : new WebSocket(socketURL, protocol);
            //set up the socket
            this.socket.onclose = this.onSocketClose.bind(this);
            this.socket.onmessage = this.onSocketMessage.bind(this);
            this.socket.onerror =  this.onSocketError.bind(this);
        },
        handleDataLoad: function (result) {
            Superclass.handleDataLoad.call(this, result);
            
            if (result && result.data && this.canOpenSocket()) {
                this.setUpSocket();
            }

        },
        resetSocketState: function () {
            Object.assign(this, initSocketState);
        },
        start: function () {
            Superclass.start.call(this);
        },
        pause: function () {
            Superclass.pause.call(this);
            this.preventReconnection = true;
        },
        stop: function () {
            Superclass.stop.call(this);
            this.clean();
            this.resetSocketState();
        },
        clean: function () {
            // null check here to prevent issues with speedy game switching before the socket is open
            !!this.socket && this.socket.close();
            this.pushUpdateId = null;
            this.socket = null;
        },
        setAccessToken: function (accessToken) {
            const socket = this.socket;
            if (accessToken !== SocketApiHeartbeatItem.authAccessToken) {
                SocketApiHeartbeatItem.authAccessToken = accessToken; // set access token   
            } 
            if (socket && (socket.readyState === socket.OPEN)) {
                this.clean(); // clean the socket so we can reconnect websocket when access token is updated
            }
        }
    });

    SocketApiHeartbeatItem.authAccessToken = null;

    Superclass = SocketApiHeartbeatItem.superclass;

    return SocketApiHeartbeatItem;
});
